export const clearNotifications = () => {
  return {
    type: "CLEAR_NOTIFICATIONS",
  };
};
